import sortBy from 'lodash/sortBy';
import { ICtxEntity } from '@/providers/EntitiesListContextProvider/EntitiesListContext.types';

export const sortAscEntitiesBy = (entities: ICtxEntity[], key: 'value' | 'label') => {
  return sortBy(entities, entity => entity[key].toLowerCase());
};
